export default __webpack_public_path__ + "static/media/corner.7d61a3e7.svg";